import { buildApiUrl } from '#app/lib/treq'
import type { FeedsParams } from '#server/controllers/feeds/feeds'
import type { AbsoluteUrl } from '#server/types/common'
import { mainUser } from '#user/lib/main_user'

export function feedsAPI (key: string, id: string) {
  const query: Partial<FeedsParams> = {}
  query[key] = id
  if (mainUser) {
    query.requester = mainUser._id
    query.token = mainUser.readToken
  }

  const relativeUrl = buildApiUrl('feeds', 'get', 'default', query as FeedsParams)

  // Always using the absolute path so that links are treated as external links,
  // thus getting target='_blank' attributes, and the associated click behaviors
  // cf app/modules/general/lib/smart_prevent_default.js
  return `${window.location?.origin}${relativeUrl}` as AbsoluteUrl
}
